import NavigationContextInterface from "@app/Interface/NavigationContextInterface";
import NotificationContextInterface from "@app/Interface/NotificationContextInterface";
import PageRouteContextInterface from "@app/Interface/PageRouteContextInterface";
import ToastContextInterface from "@app/Interface/ToastContextInterface";
import UserContextInterface from "@app/Interface/UserContextInterface";
import PasswordStatusType from "@app/Type/PasswordStatusType";
export default class TypeAssertions {

    /**
     * Useful switch statements where there is 
     * a case that wasn't handled.
     * 
     * @param x unknown
     */
    static assertNever = (x: unknown): ToastContextInterface => {
        throw new Error(`Unexpected object: ${x}`);
    }

    /**
     * Useful switch statements where there is 
     * a case that wasn't handled.
     * 
     * @param x unknown
     */
    static assertNeverNotificationAction = (x: unknown): NotificationContextInterface => {
        throw new Error(`Unexpected object: ${x}`);
    }

    /**
     * Useful switch statements where there is 
     * a switch case that wasn't handled.
     * 
     * @param x unknown
     */
    static assertNeverUserAction = (x: unknown): UserContextInterface => {
        throw new Error(`Unexpected object: ${x}`);
    }

    /**
     * Useful switch statements where there is 
     * a switch case that wasn't handled.
     * 
     * @param x unknown
     */
    static assertNeverNavigationAction = (x: unknown): NavigationContextInterface => {
        throw new Error(`Unexpected object: ${x}`);
    }

    /**
     * Useful switch statements where there is 
     * a switch case that wasn't handled.
     * 
     * @param x unknown
     */
    static assertNeverPageRouteAction = (x: unknown): PageRouteContextInterface => {
        throw new Error(`Unexpected object: ${x}`);
    }

    /*
     * Check a string variable's state
     * @param value string
     * @returns boolean
     */
    static isStringNullOrEmpty = (value: string | number | boolean | undefined | null): boolean => {

        let isNullOrEmpty = false;

        if (value === "" || value === undefined || value === null) {
            isNullOrEmpty = true;
        }

        return isNullOrEmpty;
    }


    /**
     * Temporary stub for checking valid email address
     * @param value 
     * @returns 
     */
    static isEmail = (value: string | number | undefined | null): boolean => {

        let valid = false;

        if (typeof value === "string") {
            valid = true;
        }

        return valid;

    }

    /**
     * Tests if phone number is valid E164 
     * see: https://blog.kevinchisholm.com/javascript/javascript-e164-phone-number-validation/
     * 
     * @param value 
     * @returns 
     */
    static isValidE164Number = (value: string): boolean => {

        const regEx = /^\+[1-9]\d{10,14}$/;

        return regEx.test(value);

    }

    /**
     * Checks the value to the password rules
     * 
     * @param value 
     * @returns 
     */
    static isSecurePassword = (value: string): PasswordStatusType => {

        let status: PasswordStatusType = "good";

        if (value.length < 6) {
            status = "length";
        }

        return status;

    }



}